import { useState, useEffect, useRef, useCallback } from "react";
// import backgroundimg from "../Images/banner-bg.jpg";
// import Calenderimg from "../Images/provider/treatment_img.png";
import emailjs from "emailjs-com";
import { countriesList } from "../utility/constants";
import { styled, useMediaQuery } from "@material-ui/core";
import { Helmet } from "react-helmet";
import CenteredAlert from "./CenteredAlert";
import ServiceCall from "../ServiceCall";
import CircularProgress from "@material-ui/core/CircularProgress";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import whatsapp from "../Images/whatsapp.png";
// import { revolutionizes } from "./config";
import { revolutionizes } from "./config";
import NukaCarousel from "../tools/NukaCarousel";
import { faqs } from "./config";
import {
  ArrowRight,
  CheckCircle,
  Phone,
  Mail,
  Clock,
  MapPin,
  User,
  Send,
  FileText,
  Heart,
  MessageSquare,
  Users,
  DollarSign,
  Headphones,
  Plus,
  Minus,
} from "lucide-react";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ReCAPTCHA from "react-google-recaptcha";
import {
  TextField,
  Button,
  Container,
  makeStyles,
  FormControl,
  InputLabel,
  InputAdornment,
  Input,
  MenuItem,
  FormHelperText,
  Select,
  Grid,
} from "@material-ui/core";
import HospitalTreatmentsShowcase from "./HospitalTreatmentsShowcase";
const useStyles = makeStyles((theme) => ({
  button: {
    // margin: theme.spacing(2, 0),
    backgroundColor: "#008b91",
    marginTop: "2rem",
    "&:hover": {
      // Remove hover effect
      backgroundColor: "#02585c",
    },
  },
  arrowIcon: {
    position: "absolute",
    top: "70px",
    left: theme.spacing(2),
    cursor: "pointer",
  },
  nextButton: {
    backgroundColor: "#008b91",
    marginTop: "2rem",
    color: "#fff",
    "&:hover": {
      // Remove hover effect
      backgroundColor: "#02585c",
    },
    "&:disabled": {
      backgroundColor: "#ccc",
      color: "#666",
    },
  },
  recaptcha: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
  },
  header: {
    fontSize: "41px",
    marginTop: (props) =>
      props.isMobile ? "69px" : props.step === 1 ? "-293px" : "-362px",

    color: "#fff",
    fontWeight: 600,
    marginBottom: theme.spacing(4),
    textAlign: "center",
  },
}));

const Patientregis = () => {
  const [loader, setLoader] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [phoneCode, setPhoneCode] = useState("+91");
  const [countryname, setCountryname] = useState("India");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState("");
  const [know, setKnow] = useState("");
  const [country, setCountry] = useState("India");
  const [city, setCity] = useState("");
  const isMobile = useMediaQuery("(max-width:710px)");
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false); // State for managing loading state
  const [expandedQuestions, setExpandedQuestions] = useState([]);
  const [step, setStep] = useState(1);
  const [isStep1Valid, setIsStep1Valid] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [preferredHospital, setPreferredHospital] = useState("");
  const [preferredLocation, setPreferredLocation] = useState("");
  const classes = useStyles({ step, isMobile });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isValidPhoneNumber = (phoneNumber) => {
    const numericPhoneNumber = phoneNumber.replace(/\D/g, "");
    return numericPhoneNumber.length === 10 && /^\d+$/.test(numericPhoneNumber);
  };

  const showAlerts = () => {
    setShowAlert(true);
    resetForm();
  };
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const statesOfIndia = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];
  const [expandedId, setExpandedId] = useState(null);

  const toggle = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };
  const ServiceCard = ({ icon: Icon, title, description }) => (
    <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition">
      <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-teal-100 text-teal-600 rounded-full">
        <Icon className="w-8 h-8" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );

  const formRef = useRef(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const resetForm = () => {
    setName("");
    setEmail("");
    setMessage("");
    setAge("");
    setGender("");
    setKnow("");
    setPhone("");
    setCountry("");
    setCity("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
       const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
      return;
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
      return;
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone must be 10 digits";
      return;
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      return;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Email is invalid";
        return;
    }
    if (!formData.address.trim()) {
      newErrors.address = "Address is required";
      return;
    }

    setErrors(newErrors);
    setLoading(true);

    const mode = process.env.REACT_APP_MODE; // e.g., 'dev', 'prod'

    const payload = {
      email: formData.email,
      country_code: "+91", // 🔧 Replace with dynamic code if available
      phone: formData.phone,
      name: formData.name,
      address: formData.address,
      source_url: "https://rxone.app/treatment-advice",
      request_type: "treatment-advice",
      coupon_code: "", // 🔧 Optional: add value if needed
    };

    try {
      await ServiceCall.post(
        `/rxopd/rxone/patient/treatment/advice/contactus/form/${mode}`,
        payload
      );

      setSubmitted(true);
      setTimeout(() => {
        setFormData({ name: "", email: "", phone: "", address: "" });
        setSubmitted(false);
      }, 3000);
    } catch (error) {
      console.error("API submission error:", error);
      alert("Failed to submit the form. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const isValid =
      name.trim() !== "" &&
      age.trim() !== "" &&
      gender !== "" &&
      message.trim() !== "";
    setIsStep1Valid(isValid);
  }, [name, age, gender, message]);

  const titlle =
    "FREE Treatment Advice - Consult for Medical Treatment Advice - Allopathy, Homeopathy, Ayurveda, Unani, Sowa-Rigpa, Siddha, Yoga, Reki, Naturopathy, Meditation, Physiotherapy, Mental Health | RxOne";
  const desc =
    "Get free treatment advice and consult for medical treatments including Allopathy, Homeopathy, Ayurveda, Unani, Sowa-Rigpa, Siddha, Yoga, Reki, Naturopathy, Meditation, Physiotherapy, and Mental Health at RxOne.";


  const handleNext = () => {
    if (isStep1Valid) {
      setStep(2);
    }
  };



  const handleContactNowClick = () => {
    const section = document.getElementById("consultation");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
      <Helmet>{<title>{titlle}</title>}</Helmet>
      <Helmet>{<meta name="description" content={desc} />}</Helmet>
      <div className="bg-gradient-to-br from-teal-100 via-white to-blue-50 min-h-screen">
        <section
          id="consultation"
          className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 mt-20 "
        >
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div>
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                  Talk to <span className="text-teal-600">Medical Experts</span>{" "}
                  for <span className="text-teal-600">Free</span>
                </h1>
                <p className="mt-6 text-xl text-gray-600 leading-relaxed">
                  Get instant access to qualified medical professionals. No
                  appointments needed, no waiting rooms. Just expert medical
                  advice when you need it most.
                </p>
              </div>

              <div className="flex flex-wrap gap-4">
                <a
                  href="#services"
                  className="inline-flex items-center px-6 py-3 bg-teal-600 text-white font-medium rounded-lg shadow-md hover:bg-teal-700 transition-colors"
                >
                  Contact Us
                  <ArrowRight className="ml-2 h-5 w-5" />
                </a>
                {/* <a
  href="#contact"
  className="inline-flex items-center px-6 py-3 bg-white text-teal-600 border border-teal-600 font-medium rounded-lg transition-colors hover:bg-teal-50 hover:text-teal-700 hover:border-teal-700"
>
  Contact Us
</a> */}
              </div>

              <div className="space-y-4 pt-2">
                <div className="flex items-center gap-3">
                  <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                    <Clock className="h-6 w-6" />
                  </div>
                  <span className="text-gray-700 font-medium">
                    Find answers to your medical questions
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                    <Clock className="h-6 w-6" />
                  </div>
                  <span className="text-gray-700 font-medium">
                    Find the best doctor and hospital
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="bg-teal-100 p-2 rounded-full text-teal-600">
                    <CheckCircle className="h-6 w-6" />
                  </div>
                  <span className="text-gray-700 font-medium">
                    Find the right cost of your treatment
                  </span>
                </div>
              </div>
            </div>

            <div>
              <div className="lg:pl-12" ref={formRef}>
                <div className="bg-white rounded-2xl shadow-2xl p-6 lg:p-8 relative overflow-hidden">
                  {/* Decorative Elements */}
                  <div className="absolute top-0 right-0 w-32 h-32 opacity-10 transform rotate-12">
                    <div
                      className="w-full h-full rounded-full"
                      style={{ backgroundColor: "rgb(1, 154, 158)" }}
                    ></div>
                  </div>
                  <div className="absolute bottom-0 left-0 w-24 h-24 opacity-5 transform -rotate-12">
                    <div
                      className="w-full h-full rounded-full"
                      style={{ backgroundColor: "rgb(1, 154, 158)" }}
                    ></div>
                  </div>

                  {submitted ? (
                    <div className="text-center py-4">
                      <div
                        className="w-16 h-16 mx-auto mb-3 rounded-full flex items-center justify-center"
                        style={{ backgroundColor: "rgba(1, 154, 158, 0.1)" }}
                      >
                        <CheckCircle
                          className="w-8 h-8"
                          style={{ color: "rgb(1, 154, 158)" }}
                        />
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-1">
                        Thank You!
                      </h3>
                      <p className="text-sm text-gray-600">
                        Your message has been sent successfully. We'll get back
                        to you soon.
                      </p>
                    </div>
                  ) : (
                    <>
                      <div className="text-center mb-4">
                        <h2 className="text-4xl font-extrabold text-gray-900 mb-3 flex items-center justify-center gap-3">
                          <span
                            style={{
                              letterSpacing: "1px",
                              // textTransform: "uppercase",
                              background:
                                "linear-gradient(90deg, #019a9e 0%, #00c6b7 100%)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                              display: "inline-block",
                            }}
                          >
                            Contact Now
                          </span>
                          {/* <img
    src={phantompic}
    alt="PanTum Logo"
    style={{
      display: "inline-block",
      verticalAlign: "middle",
      height: "30px",
      marginBottom: "2px"
    }}
  /> */}
                        </h2>
                        <p className="text-sm text-gray-600">
                          Fill out the form and we'll contact you within 24
                          hours
                        </p>
                      </div>

                      <div className="space-y-4">
                        {/* Name Field */}
                        <div>
                          <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
                            <User className="w-4 h-4 mr-2 text-gray-500" />
                            Full Name *
                          </label>
                          <input
                            type="text"
                            name="name"
                            placeholder="Enter your full name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                            style={{ "--tw-ring-color": "rgb(1, 154, 158)" }}
                          />
                        </div>

                        {/* Email Field */}
                        <div>
                          <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
                            <Mail className="w-4 h-4 mr-2 text-gray-500" />
                            Email Address *
                          </label>
                          <input
                            type="email"
                            name="email"
                            placeholder="Enter your email address"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                            style={{ "--tw-ring-color": "rgb(1, 154, 158)" }}
                          />
                        </div>

                        {/* Phone Field */}
                        <div>
                          <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
                            <Phone className="w-4 h-4 mr-2 text-gray-500" />
                            Phone Number *
                          </label>
                          <input
                            type="tel"
                            name="phone"
                            placeholder="Enter your phone number"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                            style={{ "--tw-ring-color": "rgb(1, 154, 158)" }}
                          />
                        </div>

                        {/* Address Field */}
                        <div>
                          <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
                            <MapPin className="w-4 h-4 mr-2 text-gray-500" />
                            Address *
                          </label>
                          <textarea
                            name="address"
                            placeholder="Enter your complete address"
                            rows="2"
                            value={formData.address}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white resize-none"
                            style={{ "--tw-ring-color": "rgb(1, 154, 158)" }}
                          />
                        </div>

                        {/* Submit Button */}
                        <button
                          type="button"
                          onClick={handleSubmit}
                          disabled={loading}
                          className={`w-full flex items-center justify-center px-6 py-3 rounded-lg font-semibold text-white transition-all duration-200 transform hover:scale-105 hover:shadow-lg ${
                            loading
                              ? "opacity-70 cursor-not-allowed"
                              : "hover:shadow-xl"
                          }`}
                          style={{
                            backgroundColor: loading
                              ? "#gray"
                              : "rgb(1, 154, 158)",
                            boxShadow: loading
                              ? "none"
                              : "0 4px 15px rgba(1, 154, 158, 0.3)",
                          }}
                        >
                          {loading ? (
                            <>
                              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                              Submitting...
                            </>
                          ) : (
                            <>
                              <Send className="w-5 h-5 mr-2" />
                              Submit
                            </>
                          )}
                        </button>

                        {/* Trust Indicators */}
                        {/* <div className="pt-3 border-t border-gray-100">
            <div className="flex items-center justify-center space-x-4 text-xs text-gray-500">
              <div className="flex items-center">
                <Shield className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                SSL Secured
              </div>
              <div className="flex items-center">
                <CheckCircle className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                No Spam
              </div>
              <div className="flex items-center">
                <Star className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                Trusted
              </div>
            </div>
          </div> */}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {showAlert && (
        <CenteredAlert
          message="We have received your request, please allow us up-to 24 Hrs. to come back to you."
          onClose={() => setShowAlert(false)}
        />
      )}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              How It Works
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Getting expert medical advice has never been easier. Follow these
              simple steps to connect with our medical professionals.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
            {/* Step 1 */}
            <div className="text-center relative">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6 relative">
                <Phone className="w-10 h-10 text-white" />
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-cyan-500 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-sm">1</span>
                </div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Our Medical Expert Will Call You Within 24 Hours
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Once you submit your details, our qualified medical expert will
                reach out to you within 24 hours to understand your health
                concerns and medical history.
              </p>
              <div className="hidden md:block absolute top-10 left-full w-full h-0.5 bg-gray-200 transform -translate-y-1/2 z-0">
                <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-teal-600 rounded-full"></div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="text-center relative">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6 relative">
                <FileText className="w-10 h-10 text-white" />
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-cyan-500 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-sm">2</span>
                </div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Our Expert Will Share a Treatment Proposal
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Based on your consultation, our medical expert will provide you
                with a detailed treatment plan, including doctor recommendations
                and cost estimates.
              </p>
              <div className="hidden md:block absolute top-10 left-full w-full h-0.5 bg-gray-200 transform -translate-y-1/2 z-0">
                <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-teal-600 rounded-full"></div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6 relative">
                <Heart className="w-10 h-10 text-white" />
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-cyan-500 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-sm">3</span>
                </div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Experience Stress Free Medical Journey
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Follow your personalized treatment plan with our continuous
                support and guidance, ensuring a smooth and worry-free
                healthcare experience.
              </p>
            </div>
          </div>

          {/* Custom CTA Button */}
          <div className="text-center mt-12">
            <button
              className="px-6 py-3 text-lg font-semibold text-white bg-teal-600 hover:bg-teal-700 rounded-lg transition duration-300"
              onClick={handleContactNowClick}
            >
              Contact Now
            </button>
          </div>
        </div>
      </section>
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Everything You Need for Better Health
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our comprehensive medical consultation platform provides you with
              expert guidance, helping you make informed decisions about your
              health and wellness.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <ServiceCard
              icon={MessageSquare}
              title="Find Answers to Your Medical Questions"
              description="Get expert medical advice and answers to your health concerns from qualified professionals available 24/7."
            />
            <ServiceCard
              icon={Users}
              title="Find the Best Doctor and Hospital"
              description="Connect with top-rated doctors and hospitals in your area based on your specific medical needs and location."
            />
            <ServiceCard
              icon={DollarSign}
              title="Find the Right Cost of Your Treatment"
              description="Get transparent pricing information and cost estimates for various medical treatments and procedures."
            />
            <ServiceCard
              icon={Headphones}
              title="Get Assistance for Everything in Between"
              description="Our care advisors provide comprehensive support throughout your healthcare journey, from consultation to treatment."
            />
          </div>
        </div>
      </section>
      <HospitalTreatmentsShowcase />
      <section className="py-16 bg-teal-600">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Join thousands of patients who trust us for their medical
            consultation needs. Start your free consultation today.
          </p>
          <button
            className="px-6 py-3 bg-white text-teal-600 text-lg font-semibold rounded-lg hover:bg-gray-100 transition duration-300"
            onClick={handleContactNowClick}
          >
            Get Call from Care Advisor
          </button>
        </div>
      </section>
      <section className="py-20 bg-gray-50">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-10 text-center">
            Frequently Asked Questions
          </h2>

          <div className="space-y-5">
            {faqs.map((faq) => (
              <div
                key={faq.id}
                className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => toggle(faq.id)}
                  className="flex justify-between items-center w-full px-4 py-4 text-left text-gray-800 font-medium hover:bg-gray-100 focus:outline-none"
                >
                  <span className="text-sm sm:text-base">{faq.question}</span>
                  <span className="ml-4 text-teal-600">
                    {expandedId === faq.id ? (
                      <Minus size={18} />
                    ) : (
                      <Plus size={18} />
                    )}
                  </span>
                </button>

                <div
                  className={`px-4 pt-0 pb-4 text-gray-600 text-sm transition-all duration-300 ${
                    expandedId === faq.id ? "block" : "hidden"
                  }`}
                >
                  {faq.answer}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
export default Patientregis;
